import React, { Component } from 'react';
import BarcodeScannerComponent from "react-webcam-barcode-scanner";
import { connect } from "react-redux";
import noImage from '../../../assets/images/noProductImg_420x420.jpg'
import { bindActionCreators } from "redux";
import { getCSAProductList, sendCsaProductSearchValue } from "../../../actions/csaApp";
// import { segregateCart} from '../../../actions/checkout';
import { segregateCart } from '../../../actions/checkout';
import {getCartInfo} from '../../../actions/cart';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { updateUserInfo,getWebSessionId } from '../../../actions/user';
import { updateUserInfo as updateuser } from '../../../actions/updUserInfo'
import { getOrderList } from '../../../actions/order';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.scss';
import { Link } from 'react-router-dom';
import { editDefault } from '../../common/MangoIcons'
import Modal from 'react-responsive-modal';
import { capillarySearchMember, easyRewardsSearchMember, registerCapillaryAccount, updateCapillaryProfileMember } from '../../../actions/easyRewards';
import { updateUserAddr } from '../../../actions/updUserAddr';
import axios from "axios";

const getStateCityZipUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/get-state-city-by-zipcode`;





class ConsumerDetails extends Component{
    constructor(){
        super()
        this.state = {
            mobile_no: null,
            consumer_name: null,
            userDetails : [],
            easyMemberDetail : [],
            showUser : false,
            open: false,
            errorMessage:'',
            matches: window.matchMedia("(max-width: 420px)").matches,
        }
    }
   async componentDidMount() {
        const { updateUserInfo, connection_id,getOrderList,tenant_name } = this.props;
        const options = {
          connection_id,
          mobile_no: localStorage.getItem('mobile_no'),
          tenant_name:tenant_name
          
        }
       // updateUserInfo(options)
        if(localStorage.getItem('mobile_no')){
            
            this.setState({mobile_no:localStorage.getItem('mobile_no')})
            this.state.mobile_no = this.state.mobile_no
            let options = {
                "connection_id": this.props.connection_id,
                "mobile_no": localStorage.getItem('mobile_no'), 
                tenant_name:tenant_name
                }
            updateUserInfo(options);
            getOrderList(this.props.connection_id,localStorage.getItem('mobile_no'),tenant_name); 
            if(!this.props.loading){
                this.setState({
                    showUser: true,
                })

            }
              if(this.props.easyRewardsFlag === "Y"){
            const data = {
        mobile_no: localStorage.getItem('mobile_no'),
        token: this.props.configDetails ? this.props.configDetails.Token : "",
      };
       let res =  await this.props.easyRewardsSearchMember(data);
        let dataAll = res.data.MemberResponse ? res.data.MemberResponse : {} 
        this.setState({
           easyMemberDetail :  dataAll
        })

    }else if(this.props.capillaryFlag === "Y"){
        const data = {
            mobile_no: localStorage.getItem('mobile_no'),
            connection_id:connection_id
          };
          await this.props.capillarySearchMember(data);
            // let dataAll = res.data.MemberResponse ? res.data.MemberResponse : {} 
            // this.setState({
            //    capillaryMemberDetail :  dataAll
            // })
    }
          
            //localStorage.removeItem('mobile_no')
        }else {

        }
    }
   getStateCityByZipcode = async (value) => {
  const { connection_id } = this.props;

  try {
    const res = await axios.get(getStateCityZipUrl, {
      params: {
        connection_id,
        zipcode: value,
      },
    });

    if (res.data.ack === "Failure") {
     // toast.error('Pin code not found from third party, please update address');
      return '';
    } else {
      return res.data.results ? res.data.results.data : '';
    }

  } catch (error) {
    console.error("Zipcode API Error:", error);
    toast.error("Something went wrong while fetching location.");
    return null;

  }
};

    onOpenModal = (msg) => {
        this.setState({ open: true,
            errorMessage : msg
         });
    };

    onCloseModal = () => {
        this.setState({ open: false });
        document.getElementById('mobile_no').focus();
    };

    handleChange(event) {

        let value = event.target.value;
        value  = value.replace(/\D/g, '').slice(0, 10);
        this.setState({ [event.target.id]: value });       
    }

    getConsumerDetails = async () => {
  const { mobile_no, consumer_name } = this.state;
  const { updateUserInfo, userInfo,store_details,configDetails, easyRewardsSearchMember,segregateCart, connection_id, loading, user_details, getOrderList, tenant_name } = this.props;
  let maxLen = store_details && store_details.tenant_name == 'D Samson Industries (Pvt) Ltd' ? 9 : 10 ;
 
  if (mobile_no && mobile_no.length == maxLen ) {
    try {
      // Step 1: Prepare payloads
      const options = {
        connection_id,
        mobile_no,
        tenant_name,
      };

      const optionsForCart = {
        connection_id,
        consumer_mobile_no: userInfo ?userInfo.COM_CONSUMER_MOBILE_NO:'',
        consumer_name: userInfo?userInfo.COM_FNAME:'',
        web_session_trans_id: this.props.web_session_trans_id,
      };

      const optionsForCartdetail = {
        connection_id: this.props.connection_id,
        web_session_trans_id: this.props.web_session_trans_id,
      };

      // Step 2: Fetch consumer details
      if (this.props.easyRewardsFlag === "Y") {
      const data = {
        mobile_no: mobile_no,
        token: configDetails?configDetails.Token : "",
      };
      await easyRewardsSearchMember(data);
        if(this.props.memberDetails && this.props.memberDetails.data.ReturnMessage ) { 
 this.onOpenModal(`${this.props.memberDetails.data.ReturnMessage} please register consumer`);
            return;
         }

    }else if(this.props.capillaryFlag === "Y"){
        const data = {
            mobile_no: mobile_no,   
            connection_id: connection_id,
          };
        let res =   await this.props.capillarySearchMember(data);
        

             if(res.data && res.data.msg ) { 
                await updateUserInfo(options);
                if(Object.keys(this.props.user_details).length){
                    //this.onOpenModal(res.data.data.customers.customer[0].item_status.message)
                    let errMsg = `Consumer not Registered in Third party. Click Ok to register and continue.` 
                    this.onOpenModal(errMsg)
                    return;
                }
                
                let errMsg = `Customer not Registered. Proceed with Consumer detail entry`
                
    //  this.onOpenModal(`${res.data.data.customers.customer[0].item_status.message} please register consumer`);
      this.onOpenModal(`${errMsg}`);
                 return;
              }
    }

      await updateUserInfo(options);
    
     


      // Step 3: Fetch order list and cart info
      await getOrderList(connection_id, mobile_no, tenant_name);
      await this.props.getCartInfo(optionsForCartdetail);

      // Step 4: Handle cart segregation if items exist
      if (this.props.total > 0) {
        await segregateCart(optionsForCart, "Y");
      }

      // Step 5: Refresh session ID and cart info
      await this.props.getWebSessionId(connection_id);
      await this.props.getCartInfo(optionsForCartdetail);

      // Step 6: After all data fetched, open modal
      if (!loading) {
        this.setState({ showUser: true });
        // <-- Move here
      }
      if(this.props.errorUserForm  && this.props.errorUserForm !== null )
      {
 this.onOpenModal(this.props.errorUserForm.message);
      }
    } catch (error) {
      console.error("Error fetching consumer details:", error);
      toast.error("Failed to fetch consumer details. Please try again.");
    }
  } else {
    toast.error("Please enter a valid mobile number");
  }
};
handleOkClick = async (e) => {
let {user_details,capillaryMemberDetails,registerCapillaryAccountDetails,connection_id} = this.props;
const options = {
        connection_id:this.props.connection_id,
        mobile_no:this.state.mobile_no,
        tenant_name:this.props.tenant_name,
      };

    e.preventDefault();
    if(this.state.errorMessage.includes && this.state.errorMessage.includes('Click Ok to register and continue.') ){
        let data = {
          connection_id: this.props.connection_id,
          mobile_no: this.state.mobile_no,
          firstName: user_details.COM_FNAME,
          lastName: user_details.COM_LNAME,
          emailId: user_details.COM_EMAIL_ID,
          address1: user_details.COM_ADDRESS1,
          address2: user_details.COM_ADDRESS2,
          address3: user_details.COM_ADDRESS3,
          stateName: user_details.COM_STATE_NAME,
          countryName: user_details.COM_CONTRY_NAME,
          townName: user_details.COM_TOWN_NAME,
          pinCode: user_details.COM_PIN,
          dob : user_details.COM_DOB
        };
    let registerResponse = await this.props.registerCapillaryAccount(data)

      let registerData = registerResponse && registerResponse.data &&  registerResponse.data.length > 0 ? registerResponse.data[0] : null;
      if(registerData){
        if(registerData.customer_details.mobile == 91+this.state.mobile_no){
            await this.props.updateCapillaryProfileMember(data)
          await this.props.updateUserInfo(options);
        }else {
                toast.error('Mail address is existing in thirdparty, please update profile with correct mail address');
                 this.props.history.push("/update");
        }
      }
      
      this.setState({ open: false });
      return;
    }else if(capillaryMemberDetails && capillaryMemberDetails.data && capillaryMemberDetails.data.data && capillaryMemberDetails.data.data.length > 0) {

let pinData = await this.getStateCityByZipcode(capillaryMemberDetails.data.data[0].customer_details.extended_fields.zip);
    

     const optionsadd = {
             connection_id, user_data: {
                cons_mobile_no: this.state.mobile_no,
               ship_addr_1:capillaryMemberDetails.data.data[0].customer_details.custom_fields.addressone,
               ship_addr_2:capillaryMemberDetails.data.data[0].customer_details.custom_fields.addresstwo,
               ship_addr_3:capillaryMemberDetails.data.data[0].customer_details.custom_fields.addressthree,
               ship_pin:capillaryMemberDetails.data.data[0].customer_details.extended_fields.zip,
               ship_country_name:pinData.CON_NAME,
               ship_country_id:pinData.PNM_COUNTRY_CD,
               ship_state_name:pinData.LPN_STATE_NAME,
               ship_state_id:pinData.PNM_STATE_CD,
               ship_town_name:pinData.LPN_TOWN_NAME,
               ship_town_id:pinData.PNM_TOWN_CD,

                bill_addr_1: capillaryMemberDetails.data.data[0].customer_details.custom_fields.addressone,
           bill_addr_2: capillaryMemberDetails.data.data[0].customer_details.custom_fields.addresstwo,
           bill_addr_3: capillaryMemberDetails.data.data[0].customer_details.custom_fields.addressthree,
           bill_pin: capillaryMemberDetails.data.data[0].customer_details.extended_fields.zip,
           bill_country_name: pinData.CON_NAME,
           bill_country_id: pinData.PNM_COUNTRY_CD,
           bill_state_name: pinData.LPN_STATE_NAME,
           bill_state_id: pinData.PNM_STATE_CD,
           bill_town_name: pinData.LPN_TOWN_NAME,
           bill_town_id: pinData.PNM_TOWN_CD,
            
             }
           }
            let userData = {
         connection_id: connection_id,
        user_data: {
          cons_first_name: capillaryMemberDetails.data.data[0].customer_details.firstname,
          cons_last_name: capillaryMemberDetails.data.data[0].customer_details.lastname,
          cons_email_id: capillaryMemberDetails.data.data[0].customer_details.email,
          cons_dob: capillaryMemberDetails.data.data[0].customer_details.dob,
          cons_mobile_no:
            localStorage.getItem('mobile_no'),
            
        },
      }

      if(pinData == ''){
        await this.props.updateuser(userData)
         await  this.props.updateUserInfo(options);
            this.setState({ open: false });
            //this.props.history.push("/profile/edit-address");
        return;
    }else {
        await this.props.updateuser(userData)
          await  this.props.updateUserInfo(options);
      
          await  this.props.updateUserAddr(optionsadd)
           
           this.setState({ open: false });
    }
    }else {
    

    
    
    await this.props.updateUserInfo(options);
     this.props.history.push("/update");
     localStorage.setItem('mobile_no',this.state.mobile_no)
  
  this.setState({ open: false });
    }
};

    render(){
        const { showUser, matches } = this.state; 
        const { symbol, capillaryFlag,user_details, loyalty_details, ewallet_details, orderItems, sales_details,store_details,capillaryMemberDetails} = this.props;

        let capilartyData = capillaryFlag == 'Y' ? capillaryMemberDetails && capillaryMemberDetails.data && capillaryMemberDetails.data.data.length > 0 && capillaryMemberDetails.data.data[0].customer_details ? capillaryMemberDetails.data.data[0].customer_details : '':'';
       let capAddr = capilartyData != '' && capilartyData.custom_fields ? capilartyData.custom_fields : '' ;
       let capZip = capilartyData != '' && capilartyData.extended_fields ? capilartyData.extended_fields : '' ;
  
        if(showUser && user_details && user_details.COM_CONSUMER_MOBILE_NO ){
            localStorage.setItem('mobile_no',user_details && user_details.COM_CONSUMER_MOBILE_NO);
         }
        return(
            <React.Fragment>
                <div className="csa-consumer-details" style={{paddingBottom:20}}>
                    <div className="container">
                    <div className="container-tab mx-auto">
                        <div class="row">
                            <div class="col-md-8 mx-auto">

                                 {/* Title */}

                                 <div className="row csa_consumer_title" style={{paddingBottom:40}}>
                                        <div className="col-sm-12 text-center">
                                            <div className="mini-title">
                                                <span className="mx-auto">Consumer Details</span>
                                            </div>
                                        </div>
                                    </div>

                                {/* Consumer Details */}
                                <div style={{padding:15}}>
                                <div className="size-box row" style={{ paddingBottom: 10}}>
                                    <div className="col-md-3 col-sm-3 col-xs-3" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left",  marginBottom: 10, marginTop: 5 }}>
                                            Mobile No
                                    </div>
                                    <div className="col-md-8 col-sm-8 col-xs-8" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 15 }}>
                                        <input type="text" pattern="[0-9]{10}" maxLength={store_details && store_details.tenant_name == 'D Samson Industries (Pvt) Ltd' ? 9 : 10 }  className="form-control" id="mobile_no"
                                                placeholder="Enter Mobile No" value={this.state.mobile_no} onChange={(e) => this.handleChange(e)}  />
                                    </div>
                                </div>

                                <div className="size-box row" style={{ paddingBottom: 10}}>
                                    <div className="col-md-3 col-sm-3 col-xs-3" style={{ paddingLeft: 0, paddingRight: 0, textAlign: "left",  marginBottom: 10, marginTop: 5 }}>
                                    Consumer Name
                                    </div>
                                    <div className="col-md-8 col-sm-8 col-xs-8" style={{ paddingLeft: 0, paddingRight: 0, marginBottom: 15 }}>
                                        {user_details ?   
                                        
                                        <input type="text" className="form-control" id="consumer_name"
                                                placeholder="Enter Consumer Name" value={ user_details.COM_FNAME ? user_details.COM_FNAME : ''} onChange={(e) => this.handleChange(e)} readOnly />
                                                :
                                                <input type="text" className="form-control" id="consumer_name"
                                                placeholder="Enter Consumer Name"  onChange={(e) => this.handleChange(e)} readOnly /> 
                                             } 
                                        </div>
                                </div>

                                <div className="size-box" style={{ paddingBottom: 20}}>
                                    <div className="row">
                                        <div className="col-md-2 col-sm-2   col-xs-2 mx-auto">
                                            <button className="btn btn-solid csa-product-btn"  type="submit" onClick={(e) => this.getConsumerDetails(e)}>Go</button>
                                        </div>
                                    </div>
                                </div>
                                </div>

                                {/* End Consumer Details */}


                                <section className="tab-product csa-products m-0" >
                                    <div className="row">
                                        <div className="col-sm-12 col-lg-12">
                                            <Tabs className="tab-content nav-material">
                                                <TabList className="nav nav-tabs nav-material">
                                                    {/* <Tab className="nav-item">
                                                        <span className="nav-link" >
                                                            {matches && <i className="fa fa-home" aria-hidden="true"></i>}<br/>
                                                            <span className="tab_title">Home</span>
                                                        </span>
                                                        <div className="material-border"></div>
                                                    </Tab> */}
                                                    <Tab className="nav-item">
                                                        <span className="nav-link" >
                                                            {matches && <i className="fa fa-user" aria-hidden="true"></i>}<br/>
                                                            <span className="tab_title">Profile</span>
                                                        </span>
                                                        <div className="material-border"></div>
                                                    </Tab>
                                                    <Tab className="nav-item">
                                                        <span className="nav-link" >
                                                            {matches && <i className="fa fa-area-chart" aria-hidden="true"></i> }<br/>
                                                            <span className="tab_title">Sales</span>
                                                        </span>
                                                        <div className="material-border"></div>
                                                    </Tab>
                                                    <Tab className="nav-item">
                                                        <span className="nav-link" >
                                                            {matches && <i className="fa fa-credit-card-alt" aria-hidden="true"></i>}<br/>
                                                            <span className="tab_title">Wallet</span>
                                                        </span>
                                                        <div className="material-border"></div>
                                                    </Tab>
                                                    <Tab className="nav-item">
                                                        <span className="nav-link" >
                                                            {matches && <i className="fa fa-archive" aria-hidden="true"></i>}<br/>
                                                            <span className="tab_title">Orders</span>
                                                        </span>
                                                        <div className="material-border"></div>
                                                    </Tab>
                                                    <Tab className="nav-item">
                                                        <span className="nav-link" >
                                                            {matches && <i className="fa fa-shopping-basket" aria-hidden="true"></i>}<br/>
                                                            <span className="tab_title">Loyalty</span>
                                                        </span>
                                                        <div className="material-border"></div>
                                                    </Tab>
                                                    
                                                </TabList>
                                                {/* Home */}
                                                {/* <TabPanel>
                                                </TabPanel> */}

                                                {/* Profile */}
                                                <TabPanel>
                                                {user_details ? 
                                                <div className="profile_details">
                                                   
                                                    {user_details.COM_CONSUMER_MOBILE_NO ?
                                                    <div className="embed-responsive">
                                                        {showUser ?
                                                        <React.Fragment>
                                                        <div className="w_100 row" style={{marginBottom: 0}}>
                                                            <div className='col-4'>Name</div>
                                                            <div className='col-1'>:</div>
                                                        <div className="col" >
                                                            {user_details.COM_FNAME}
                                                        </div>
                                                        <div  className="" style={{    marginRight: '-4%'}}>
                              <Link to="profile/edit-user"><img src={editDefault} style={{ width: 25, height:35}} /></Link>

                                                        </div>
                                                        </div>

                                                        <div className="w_100 row">
                                                        <div className='col-4'>Mobile No.</div>
                                                        <div className='col-1'>:</div>

                                                        <div className='col'>{user_details.COM_CONSUMER_MOBILE_NO}
                                                        </div></div>

                                                        <div className="w_100 row">
                                                        <div className='col-4'>DOB</div>
                                                        <div className='col-1'>:</div>
                                                         <div className='col'> {user_details.COM_DOB ? user_details.COM_DOB && 
                                                         new Date(user_details.COM_DOB).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-') 
                                                         //new Date(user_details.COM_DOB).toLocaleDateString('en-CA')
                                                         : ''}  </div>
                                                        </div>
                                                        
                                                        <div className="w_100" style={{paddingTop:20}}>
                                                            <div>
                                                                <b>Shipping Address</b>
                                                            </div>
                                                            {capillaryFlag == 'Y'  ?
                                                              <div>

                                                                <ul>
                                                                  
                                                                    <li>{capAddr.addressone || ''}</li>
                                                                    <li>{capAddr.addresstwo || ''}</li>
                                                                    {/* <li>{user_details.COM_BILL_TO_ADDRESS3}</li> */}
                                                                   <li>
  {`${capZip.city || ''}${capZip.city && capZip.state ? ', ' : ''}${capZip.state || ''}`}
</li>

<li>
  {`${capZip.country_of_residence || ''}${capZip.country_of_residence && capZip.zip ? ' - ' : ''}${capZip.zip || ''}`}
</li></ul>
                                                                
                                                            </div>  :
                                                            <div>
                                                                <ul>
                                                                    <li>{user_details.COM_ADDRESS1}</li>
                                                                    <li>{user_details.COM_ADDRESS2}</li>
                                                                    {/* <li>{user_details.COM_ADDRESS3}</li> */}
                                                                    <li>{user_details.COM_TOWN_NAME && user_details.COM_TOWN_NAME + ',' + user_details.COM_STATE_NAME}</li>
                                                                    <li>{user_details.COM_CONTRY_NAME && user_details.COM_CONTRY_NAME + '-' + user_details.COM_PIN}</li>
                                                                </ul>
                                                            </div>
    }

                                                        </div>
                                                        <div className="w_100">
                                                            <div style={{float:'left'}}>
                                                                <b>Billing Address</b>
                                                            </div>

                                                            <div style={{float:'right'}}><Link to="profile/edit-address"><img src={editDefault} style={{ width: 25, height:35}} /></Link>
                                                              </div>
                                                              {capillaryFlag== 'Y'  ?
                                                              <div>
                                                                <ul>
                                                                    <li>{capAddr.addressone || ''}</li>
                                                                    <li>{capAddr.addresstwo || ''}</li>
                                                                    {/* <li>{user_details.COM_BILL_TO_ADDRESS3}</li> */}
                                                                   <li>
  {`${capZip.city || ''}${capZip.city && capZip.state ? ', ' : ''}${capZip.state || ''}`}
</li>

<li>
  {`${capZip.country_of_residence || ''}${capZip.country_of_residence && capZip.zip ? ' - ' : ''}${capZip.zip || ''}`}
</li></ul>
                                                                
                                                            </div>  :
                                                            <div>
                                                                <ul>
                                                                    <li>{user_details.COM_BILL_TO_ADDRESS1}</li>
                                                                    <li>{user_details.COM_BILL_TO_ADDRESS2}</li>
                                                                    {/* <li>{user_details.COM_BILL_TO_ADDRESS3}</li> */}
                                                                    <li>{user_details.COM_BILL_TO_TOWN_NAME && user_details.COM_BILL_TO_TOWN_NAME +','+ user_details.COM_BILL_TO_STATE_NAME}</li>
                                                                    <li>{user_details.COM_BILL_TO_CONTRY_NAME && user_details.COM_BILL_TO_CONTRY_NAME +  '-' +  user_details.COM_BILL_TO_PIN}</li>
                                                                </ul>
                                                                
                                                            </div> 
    }
                                                        </div>
                                                        </React.Fragment>
                                                        :
                                                        ''
                                                            }
                                                    </div>
    : '' }
                                                </div> : '' }
                                                </TabPanel>
                                                {/* End Profile */}

                                                {/* Sales */}
                                                <TabPanel>
                                                    <div className="sales_details">
                                                        <div className="embed-responsive">
                                                        {showUser && sales_details !== null && 
                                                            sales_details ?
                                                            <React.Fragment>
                                                                
                                                                {sales_details.map((item, index) => {
                                                                     let dateTime = item.RID_INV_DT;
                                                                     let date = dateTime.substr(0,10);
                                                                    return (
                                                                       
                                                                    <React.Fragment key={index}>
                                                                    
                                                                    <div className="w_100">
                                                                        <div className="w_50">
                                                                            <p>{date}</p>
                                                                            </div></div>
                                                                            <div className="w_100">
                                                                        <div className="w_50">
                                                                            <img src={item.SKU_IMAGE !== null  && item.SKU_IMAGE !== ''? item.SKU_IMAGE : noImage} alt="" />
                                                                          {/*   <p>{item.COLOR} <br/> {item.SIZE}</p> */}
                                                                        </div>
                                                                        <div className="w_50 margin_details">
                                                                            <ul>
                                                                             
                                                                                <li>{item.RID_INVNO}</li>
                                                                                <li>{item.RID_SKU_CD}</li>
                                                                                <li>{item.ASM_NAME}</li>
                                                                                <li>{symbol} {item.RID_BILL_AMT}</li>
                                                                                <li>{parseInt(item.RID_QTY)} Unit</li>
                                                                                <li>{item.COLOR}/ {item.SIZE}</li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                    <hr/>
                                                                    </React.Fragment>
                                                                    )
                                                                })}
                                                                

                                                            </React.Fragment>
                                                            :
                                                            ''
                                                        }
                                                        </div>
                                                    </div>
                                                </TabPanel>

                                                {/* end Salas */}

                                                {/* Wallet */}
                                                <TabPanel>
                                                <div className="wallet_details">
                                                    <div className="embed-responsive">
                                                        {showUser && ewallet_details && ewallet_details.length > 0 &&
                                                        ewallet_details[0] && ewallet_details[0].Advances !== null || 
                                                        ewallet_details[0] && ewallet_details[0].Credit_Notes !==null || 
                                                        ewallet_details[0] && ewallet_details[0].GV_Self !==null || 
                                                        ewallet_details[0] && ewallet_details[0].Coupons !==null ?  
                                                         <React.Fragment>
                                                        <div className="row w_100">
                                                            <div className="col w_50">
                                                                 <b>Total Wallet Amount</b></div>
                                                                <div className="col-1"> :</div>
                                                            
                                                            <div className="col w_50">
                                                                
                                                                <b>&emsp;{symbol} {( parseFloat(parseFloat(ewallet_details[0].Advances) + parseFloat(ewallet_details[0].Credit_Notes) + parseFloat(ewallet_details[0].GV_Self) +  parseFloat(ewallet_details[0].Coupons)).toFixed(2))%1 > 0.5 ? 
                                                                Math.round(( parseFloat(parseFloat(ewallet_details[0].Advances) + parseFloat(ewallet_details[0].Credit_Notes) + parseFloat(ewallet_details[0].GV_Self) +  parseFloat(ewallet_details[0].Coupons)).toFixed(2))) : ( parseFloat(parseFloat(ewallet_details[0].Advances) + parseFloat(ewallet_details[0].Credit_Notes) + parseFloat(ewallet_details[0].GV_Self) +  parseFloat(ewallet_details[0].Coupons)).toFixed(2))}
                                                                </b>
                                                            </div>    
                                                        </div>

                                                        <div className="row w_100">
                                                            <div className="col w_50">
                                                                CR Note </div><div className='col-1'>: 
                                                            </div>
                                                            <div className="w_50 col">
                                                            &emsp; {symbol} {ewallet_details[0].Credit_Notes} 
                                                            </div>    
                                                        </div>
                                                        

                                                        <div className="row w_100">
                                                            <div className="col w_50">
                                                                Advance </div><div className='col-1'>: 
                                                            </div>
                                                            <div className="w_50 col">
                                                            &emsp;{symbol} {ewallet_details[0].Advances} 
                                                            </div>    
                                                        </div>

                                                        <div className="row w_100">
                                                            <div className="w_50 col">
                                                                GVs </div><div className='col-1'>: 
                                                            </div>
                                                            <div className="w_50 col">
                                                            &emsp;{symbol} {ewallet_details[0].GV_Self} 
                                                            </div>    
                                                        </div>

                                                        <div className="row w_100">
                                                            <div className="w_50 col">
                                                                Coupon (S)</div><div className='col-1'> : 
                                                            </div>
                                                            <div className="col w_50">
                                                            &emsp;{symbol} {ewallet_details[0].Coupons} 
                                                            </div>    
                                                        </div>
                                                       </React.Fragment>
                                                        :
                                                        ''
                                                        }
                                                    </div>
                                                </div>
                                                </TabPanel>
                                                {/* end Wallet */}

                                                 {/* Orders */}
                                                 <TabPanel>
                                                    <div className="sales_details">
                                                        <div className="embed-responsive">
                                                        {showUser && orderItems !== null && 
                                                            orderItems ?
                                                            <React.Fragment>
                                                                
                                                                {orderItems.map((item, index) => {
                                                                    let dateTime= item.RIH_CART_CREATE_DATE;
                                                                   let date = dateTime.substr(0,10);  
                                                                    return (
                                                                    <React.Fragment key={index}>
                                                                    <div className="w_100">
                                                                        <div className="w_50">
                                                                        <p>{date}</p>
                                                                        <p>{item.ASM_NAME}</p>
                                                                        </div>
                                                                    </div>

                                                                    <div className="w_100">
                                                                            <div className="w_50">
                                                                                <img src={item.SKU_IMAGE !== null && item.SKU_IMAGE !== '' ? item.SKU_IMAGE : noImage} alt="" />
                                                                            </div>
                                                                            <div className="w_50">
                                                                                <ul>
                                                                                    <li>{item.RPD_PRINCIPAL_ORDER_NO}</li>
                                                                                    <li>{item.SKU_CD}</li>
                                                                                    <li>{item.RPD_ORDER_QTY} Unit</li>
                                                                                    <li>{item.SKU_DESC}</li>
                                                                                    <li>{symbol} {item.RID_ITEM_PRICE} </li>
                                                                                    <li>{item.SKU_COLOUR}/ {item.SKU_SIZE}</li>
                                                                                    <li><b>{item.RPD_ITEM_STATUS_DESC}</b></li>
                                                                                </ul>
                                                                            </div>
                                                                    </div>
                                                                    {/* <div className="w_100">
                                                                        <div className="w_50">
                                                                        <p>{item.SKU_COLOUR} <br/> {item.SKU_SIZE}</p>
                                                                        </div>
                                                                    </div> */}



                                                                    
                                                                    <hr/>
                                                                    </React.Fragment>
                                                                    )
                                                                })}
                                                                

                                                            </React.Fragment>
                                                            :
                                                            ''
                                                        }
                                                        </div>
                                                    </div>
                                                </TabPanel>

                                                {/* end Orders */}

                                            {/* Loyality */}
                                            <TabPanel>
                                                <div className="loyality_details" style={{paddingBottom:'30px'}}>
                                                    <div className="embed-responsive">
                                                    {showUser && loyalty_details !== null && 
                                                        loyalty_details[0] ?
                                                        <React.Fragment>
                                                            <div className="row w_100">
                                                                <div className="col w_50">
                                                                    Program Name </div><div className="col-1">: 
                                                                </div>
                                                                <div className="col w_50">
                                                                    {loyalty_details[0].LCB_PROG_NAME}
                                                                </div>    
                                                            </div>

                                                            <div className="row w_100">
                                                                <div className="col w_50">
                                                                    Current Tier </div><div className="col-1">: 
                                                                </div>
                                                                <div className="col w_50">
                                                                    {loyalty_details[0].LCB_CURRENT_TIER_NAME}
                                                                </div>    
                                                            </div>

                                                            <div className="row w_100">
                                                                <div className="col w_50">
                                                                    Next Tier </div><div className="col-1">: 
                                                                </div>
                                                                <div className="col w_50">
                                                                    {loyalty_details[0].LCB_NEXT_TIER_NAME}
                                                                </div>    
                                                            </div>

                                                            <div className="row w_100">
                                                                <div className="col w_50">
                                                                    Accumulated Points  </div><div className="col-1">:
                                                                </div>
                                                                <div className="col w_50">
                                                                    {loyalty_details[0].LCS_TOTAL_POINT_ACCRUED_TODATE}
                                                                </div>    
                                                            </div>

                                                            <div className="row w_100">
                                                                <div className="col w_50">
                                                                    Redeem Points </div><div className="col-1">:
                                                                </div>
                                                                <div className="col w_50">
                                                                    {loyalty_details[0].LCS_TOTAL_POINT_REDEEMED_TODATE}    
                                                                </div>    
                                                            </div>
                                                            
                                                            <div className="row w_100">
                                                                <div className="col w_50">
                                                                    Balance Points </div><div className="col-1">:
                                                                </div>
                                                                <div className="col w_50">
                                                                    {loyalty_details[0].LCS_TOTAL_POINT_BALANCE_TODATE}    
                                                                </div>    
                                                            </div>
                                                            <div className="row w_100">
                                                                <div className="col w_50">
                                                                    Balance Points Value </div><div className="col-1">:
                                                                </div>
                                                                <div className="col w_50">
                                                                    {loyalty_details[0].LCS_TOTAL_VALUE_BALANCE_TODATE}    
                                                                </div>    
                                                            </div>

                                                            <div className="row w_100">
                                                                <div className="col w_50">
                                                                    Last Visit Date </div><div className="col-1">:
                                                                </div>
                                                                <div className="col w_50">
                                                                    
                                                               
                                                                {loyalty_details[0].CSM_LAST_VISITED_DT.substr(0,10)}     
                                                                </div>    
                                                            </div>

                                                            <div className="row w_100">
                                                                <div className="col w_50">
                                                                    Total Purchases </div><div className="col-1">:
                                                                </div>
                                                                <div className="col w_50">
                                                                {symbol} {loyalty_details[0].CSM_NET_AMOUNT_SPENT}      
                                                                </div>    
                                                            </div>
                                                        </React.Fragment>
                                                        :
                                                        ''
                                                    }
                                                    
                                                        
                                                    </div>
                                                </div>
                                                </TabPanel>
                                                {/* end Loyality */}

                                                

                                               
                                                
                                            </Tabs>
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                   <Modal open={this.state.open} onClose={this.onCloseModal} center showCloseIcon={false}>
  <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div className="modal-content">
      <div className="modal-body" style={{ overflow: "none" }}>
        <div className="row">
          <div className="">
            {this.state.errorMessage && this.state.errorMessage}
          </div>
        </div>
      </div>

      {/* Footer buttons */}
      <div className="modal-footer" style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={this.onCloseModal}
        >
          Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={(e)=>this.handleOkClick(e)}
        >
          Ok
        </button>
      </div>
    </div>
  </div>
</Modal>


            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    OFN_enabled: state.tenant.OFN_enabled,
    connection_id: state.tenant.connection_id,
    success: state.csa.success,
    user_details: state.user.user_details,
    errorUserForm : state.user.error,
    loyalty_details: state.user.loyalty_details,
    sales_details: state.user.sales_details,
    ewallet_details: state.user.ewallet_details,
    loading: state.user.loading,
    orderItems: state.orders.orderList,
    symbol: state.data.symbol,
    web_session_trans_id: state.user.web_session_trans_id,
    userInfo: state.user.user_details,
    total: state.cart.cartItemsCount,
    store_details: state.tenant.store_details,
  easyRewardsFlag: state.tenant.tenant_details.easy_rewards_flg || "N",
  capillaryFlag: state.tenant.tenant_details.capillary_flg || "N",

    tenant_name: state.tenant.store_details && state.tenant.store_details.tenant_name,
     configDetails: state.tenant.configDetails,
  memberDetails:state.easyRewards.memberDetails,
  capillaryMemberDetails:state.easyRewards.capillaryMemberDetails,
  registerCapillaryAccountDetails: state.easyRewards.registerCapillaryAccountDetails,


    

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getCSAProductList,updateUserAddr,registerCapillaryAccount,updateuser,updateCapillaryProfileMember,getCartInfo, sendCsaProductSearchValue,getWebSessionId,easyRewardsSearchMember,capillarySearchMember, updateUserInfo, getOrderList,segregateCart },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ConsumerDetails));